import { useGetReservationFlowMe } from '../useGetReservationFlowMe';
import { useGetReservationFlowMerchantOptIn } from '../useGetReservationFlowOptIn';

export const useGetMulpayOrderEnabledOptIn = (
  merchant_public_id: string,
):
  | {
      gmo_pg_order_enabled: boolean;
      vm_brand_available: boolean;
      jadd_brand_available: boolean;
    }
  | undefined => {
  const { data: user, isLoading: isUserLoading } = useGetReservationFlowMe();
  const { data: optIn } =
    useGetReservationFlowMerchantOptIn(merchant_public_id);

  if (isUserLoading || typeof optIn === 'undefined') return undefined;
  if (user)
    return {
      gmo_pg_order_enabled:
        optIn.gmo_pg_order_enabled && user.is_gmo_pg_order_enabled,
      vm_brand_available:
        optIn.vm_brand_available && user.is_gmo_pg_order_enabled,
      jadd_brand_available:
        optIn.jadd_brand_available && user.is_gmo_pg_order_enabled,
    };

  return {
    gmo_pg_order_enabled: optIn.gmo_pg_order_enabled,
    vm_brand_available: optIn.vm_brand_available,
    jadd_brand_available: optIn.jadd_brand_available,
  };
};
